module.exports = __webpack_public_path__ + "img/icon-instagram-farbig.d73173d5.svg";